export default __webpack_public_path__ + "static/media/QV_PoorFirstLayer.75c379cf.jpg";